import axios from 'axios'
import _get from 'lodash/get'

export const CHARITABLE_DONATIONS_GET = 'CHARITABLE_DONATIONS_GET'
export const CHARITABLE_DONATIONS_UPDATE = 'CHARITABLE_DONATIONS_UPDATE'
export const CHARITABLE_DONATIONS_SAVE = 'CHARITABLE_DONATIONS_SAVE'
export const CHARITABLE_DONATIONS_SAVING = 'CHARITABLE_DONATIONS_SAVING'
export const CHARITABLE_DONATIONS_SAVE_SUCCESS = 'CHARITABLE_DONATIONS_SAVE_SUCCESS'
export const CHARITABLE_DONATIONS_SAVE_ERROR = 'CHARITABLE_DONATIONS_SAVE_ERROR'

export const getCharitableDonations = (selfAssessmentId) => (dispatch) => {
    axios
        .get(`/charitabledonations/${selfAssessmentId}`)
        .then((response) => {
            const charitableDonations = { ...response.data, shouldFetch: false, fetchSuccessful: true }

            dispatch(updateCharitableDonations(charitableDonations))
        })
        .catch((error) => {
            if (_get(error, ['response', 'status']) === 404) {
                dispatch(updateCharitableDonations({ shouldFetch: false, fetchSuccessful: true }))
            }
        })
}

export const updateCharitableDonations = (charitableDonations) => ({
    type: CHARITABLE_DONATIONS_UPDATE,
    charitableDonations,
})

export const saveCharitableDonations = () => (dispatch, getState) => {
    const { assessment, charitableDonations } = getState()

    dispatch(charitableDonationsSaving, charitableDonations)

    axios
        .put(`/charitabledonations/${assessment.id}`, { ...charitableDonations, selfAssessmentId: assessment.id })
        .then((response) => {
            const data = { ...response.data, isAllowanceUpdate: charitableDonations.isAllowanceUpdate }

            dispatch(charitableDonationsSaveSuccess(data))
        })
        .catch((error) => {
            dispatch(charitableDonationsSaveError(charitableDonations, _get(error, ['response', 'data'])))
        })
}

export const updateAndSaveCharitableDonations = (charitableDonations) => (dispatch) => {
    dispatch(updateCharitableDonations(charitableDonations))
    dispatch(saveCharitableDonations())
}

export const charitableDonationsSaving = (charitableDonations) => ({
    type: CHARITABLE_DONATIONS_SAVING,
    charitableDonations,
})

export const charitableDonationsSaveSuccess = (charitableDonations) => ({
    type: CHARITABLE_DONATIONS_SAVE_SUCCESS,
    charitableDonations,
})

export const charitableDonationsSaveError = (charitableDonations, errorResponse) => ({
    type: CHARITABLE_DONATIONS_SAVE_ERROR,
    charitableDonations,
    errorResponse,
})
